/** Query parameters Auth0 appends when it sends the browser back to the app. */
const CALLBACK_PARAMS = ['code', 'state', 'error', 'error_description'];

/** What to tell the user about a login that Auth0 sent back with `?error=…` (null when the callback carried no error). */
export function readCallbackError(url: URL): { title: string; message: string } | null {
  const error = url.searchParams.get('error');
  if (!error) return null;

  const description = url.searchParams.get('error_description') ?? '';
  if (description === 'user is blocked') {
    return { title: 'Su cuenta ha sido bloqueada', message: 'No puede iniciar sesión en este momento.' };
  }
  return {
    title: 'No se pudo iniciar sesión',
    message: description || 'Ha ocurrido un error durante el proceso de autenticación.',
  };
}

/**
 * The same address without Auth0's callback parameters (the hash, where the router lives, is kept), or null when it
 * had none. Left in place they re-ran the login callback on every reload.
 */
export function withoutCallbackParams(url: URL): string | null {
  if (!CALLBACK_PARAMS.some((param) => url.searchParams.has(param))) return null;

  const clean = new URL(url.href);
  CALLBACK_PARAMS.forEach((param) => clean.searchParams.delete(param));
  return clean.pathname + clean.search + clean.hash;
}
